import React, {useState} from "react";
import { useNavigate } from "react-router";
import { putApi } from "../Conexiones/Models";
import { errorMessage, errorToast, successToast } from "../Utils/AlertMessage";
import { Button, CloseButton, Modal } from "react-bootstrap";

const ModalChangePassword = ({show, handleClose}) => {
    const navigate = useNavigate()
    const usuario = JSON.parse(sessionStorage.getItem('user')) 
    const idUser = usuario[0].idUsuario
    const [clave, setClave] = useState('');
    const [nuevaClave, setNuevaClave] = useState('');
    const [confirmarClave, setConfirmarClave] = useState('');
    const [isSaving, setSaving] = useState(false);

    const handleCloseUpd = () => {
        handleClose();
        setClave('');
        setNuevaClave('');
        setConfirmarClave('');
    }
    
    const store = async (e) =>{
        setSaving(true);
        e.preventDefault()
        const endpoint = 'usuarios/'+idUser;
        const data = {clave:clave,nuevaClave:nuevaClave,repetirClave:confirmarClave};
        const res = await putApi(endpoint,data);
        if(res.status === 1){
            if(res.data.message==="LA CONTRASEÑA HA SIDO ACTUALIZADA CORRECTAMENTE"){
                handleCloseUpd();
                successToast("CONTRASEÑA ACTUALIZADA");
            }else{
                errorToast("¡ERROR!",res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
        setSaving(false);
    }

    return (
        <div>
            <Modal show={show} onHide={handleClose}  id="modal-change-pass" >
                <Modal.Header className=' btncolor'>
                    <Modal.Title>CAMBIAR CONTRASEÑA</Modal.Title>
                    <CloseButton onClick={handleCloseUpd} style={{backgroundColor:"white"}} />
                </Modal.Header>
                <form onSubmit={store} >
                    <Modal.Body  style={{textAlign:'left', marginTop:'15px'}}>
                        <div className="divO">
                            <label className="obligatorio">Obligatorio *</label>  
                        </div>
                        <div className="modal-body" style={{textAlign:'left', marginTop:'-20px'}}>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">INGRESE LA CONTRASEÑA ACTUAL <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="password" className="form-control"  id="exampleFormControlInput1" required autoComplete='off'
                                onChange={e => setClave(e.target.value) }/>
                            </div> 
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput2" className="form-label">INGRESE LA NUEVA CONTRASEÑA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="password" className="form-control"  id="exampleFormControlInput2" required autoComplete='off'
                                onChange={e => setNuevaClave(e.target.value) } minLength={6}/>
                            </div> 
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput3" className="form-label">REPITA LA NUEVA CONTRASEÑA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="password" className="form-control"  id="exampleFormControlInput3" required autoComplete='off'
                                onChange={e => setConfirmarClave(e.target.value) } minLength={6}/>
                            </div>             
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="button" className="btn btn-secondary" onClick={handleCloseUpd}>CANCELAR</Button>                                               
                            {isSaving===true? 
                                <Button className="btn btn-primary" type="button" disabled >
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...
                                </Button>:
                                <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                            }
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    )
}

export default ModalChangePassword;